import React from 'react'
import style from './BatchesLocationsList.module.css'
import { Inventory } from '../../../../../assets/icons'
import { Translate } from '../../../../../language'
import TitleSVG from '../../../../../utils/components/TitleSVG/TitleSVG'
import Input from '../../../../../utils/components/Input/Input';
import Item from './Item'
import ListItems from './ListItems'

const BatchesLocationsList = ({ inventoryProducts, inventoryType, locationName }) => {
      
  return (

    <div>
      <div className={style.record_container}>
        <TitleSVG Icon={Inventory}
          titleHighlight={Translate('batchesLocationsListTitleHighlight', 'es')}
          title={Translate('batchesLocationsListTitle', 'es') + locationName} />
        
        <div className={style.record_grid_container}>
          <div className={style.record_grid}>
            <div className={style.record_grid_title}>id lote</div>
            <div className={style.record_grid_title}>stock</div>
            <div className={style.record_grid_title}>fecha de expedición</div>
            <div className={style.record_grid_title}>fecha de expiración</div>
            
            <ListItems>
                {inventoryProducts?.map(record => (
                   <Item
                    key={record._id}
                    id={record._id}
                    stock={record.quantityStock}
                    expeditionDate={new Date(record.expeditionDate).toLocaleDateString()}
                    expirationDate={new Date(record.expirationDate).toLocaleDateString()}
                  />
                
                ))}
            </ListItems>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BatchesLocationsList